export default "__VITE_ASSET__D$X2Xmzh__"